class LoyaltyMap extends HTMLElement {
    constructor() {
        super();

        const scrollContainer = this.querySelector('.loyalty-map__scroll-container');
        const scrollAnimation = anime({
            targets: scrollContainer,
            scrollLeft: scrollContainer.scrollWidth - scrollContainer.clientWidth,
            duration: 20000,
            easing: 'easeInOutQuad',
            direction: 'alternate',
            loop: true,
        });

        const stopAnimation = () => anime.remove(scrollContainer);
        const pauseAnimation = () => scrollAnimation.pause()
        const playAnimation = () => scrollAnimation.play();


        scrollContainer.addEventListener('mouseenter', pauseAnimation);
        scrollContainer.addEventListener('mouseleave', playAnimation);
        scrollContainer.addEventListener('touchstart', stopAnimation);
        scrollContainer.addEventListener('touchend', stopAnimation);
        if (scrollContainer.matches(':hover')) pauseAnimation();


        // RF: Add scroll to listener
        const scrollToElem = this.querySelectorAll('[data-scroll-to-custom]');
        scrollToElem.forEach(elem => {
            elem.addEventListener('click', (e) => {
                e.preventDefault();

                const targets = elem.dataset.scrollToCustom.split(',');

                let stoploop = false;
                targets.forEach(target => {
                    const targetElem = document.getElementById(target.trim());
                    if (!!targetElem && targetElem.checkVisibility() & !stoploop) {
                        stoploop = true;
                        targetElem.scrollIntoView({ behavior: 'smooth' });
                    }
                });
            });
        });
    }
}

customElements.define('loyalty-map', LoyaltyMap);